<!-- <section class="container-fluid">
  <div class="about-container"> -->
  
    <div class="signup-container mx-auto">

      <div class="row">
        <div class="col-md-8">
          <h2>SIGNUP</h2>

          <form [formGroup]= "signupForm" class="px-4" (ngSubmit)="onSubmit()">
            <div class="form-group">
              <label for="name">Full Name</label>
              <input type="text" class="form-control" formControlName="name" placeholder="Full Name" [ngClass]="{ 'is-invalid': submitted && f.name.errors }" />
              <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                  <div *ngIf="f.name.errors.required">Full Name is required</div>
              </div>
            </div>
            <div class="form-group">
              <label for="email">Email</label>
              <input type="email" class="form-control" formControlName="email" placeholder="Enter your email" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
              <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                <div *ngIf="f.email.errors.required">Email is required</div>
                <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
            </div>
            </div>
            <div class="form-group">
              <label for="telephone">Telephone</label>
              <input type="text" class="form-control" formControlName="telephone" placeholder="Enter Telephone number">
            </div>
            <div class="form-group">
              <label for="password">Password</label>
              <input type="password" class="form-control" formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
              <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                <div *ngIf="f.password.errors.required">Password is required</div>
                <!-- <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div> -->
            </div>                      </div>   
            <div class="form-group">
              <label for="confirmPwd">Confirm Password</label>
              <input type="password" class="form-control" formControlName="confirmPwd"  [ngClass]="{ 'is-invalid': submitted && f.confirmPwd.errors }" />
              <div *ngIf="submitted && f.confirmPwd.errors" class="invalid-feedback">
                <div *ngIf="f.confirmPwd.errors.required">Confirm Password is required</div>
                <div *ngIf="f.confirmPwd.errors.mustMatch">Passwords must match</div>
            </div>
            </div>        
            <div class="form-group text-right mt-3">
              <input type="file" (change)="onFileChanged($event)" id="profpicfile"  name="profpicfile" style="display: none"/>
              <button type="submit" class="btn btn-secondary btn-login">Signup</button>
            </div>
          </form>
        </div>
        <div class="col-md-2 text-center">
          <div class="upload-img" *ngIf="!bHasFile">
            <a (click)="triggerInput()">
            <i class="fa fa-camera" aria-hidden="true"></i><br>Add Profile<br> Photo</a>
          </div>
          <div class="upload-img" *ngIf="bHasFile" id="profpic" style="margin: 0px !important; padding: 0px !important;" >
            <a (click)="triggerInput()" class="btn">
            <img src='{{_apiBaseUrl}}/{{currentUser.userPhoto}}' class="img-fluid" id="imgProfile"/>
          </a>
          </div>
        </div>
        <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
      </div>
    </div>
  <!-- </div>
</section> -->

